import { COLORS } from '@/styles/colors';
import { flexCenter } from '@/styles/layout';
import styled from 'styled-components';

const MAX_PERCENTAGE_VALUE = 100;

export const ProgressBarWrapper = styled.div`
  background-color: ${COLORS.grey[300]};
  border-radius: 50px;
  position: relative;
  height: 8px;
  width: 100%;
`;

export const ProgressBarLine = styled.div<{ value: number; highlightOnComplete?: boolean }>`
  background-color: ${COLORS.green[350]};
  border-radius: 20px;
  ${flexCenter};
  height: 100%;
  width: 0;
  opacity: 0;
  transition: width ease 0.3s;

  ${({ highlightOnComplete, value }) =>
    highlightOnComplete &&
    value >= MAX_PERCENTAGE_VALUE &&
    `
    background-color: ${COLORS.red[200]};
  `};

  ${({ value }) =>
    value &&
    `
    width: ${value > MAX_PERCENTAGE_VALUE ? MAX_PERCENTAGE_VALUE : value}%;
    opacity: 1;
  `};
`;
